// scadenzario-api.js — amm-v3 (A2, ondata 29): parte PURA della vista "Regole
// degli obblighi" (pagina 'scadenzario' — il CATALOGO delle regole che
// generano le scadenze, spike o27 §1.2), testabile sotto node (contract test
// server/src/lib/amm-v3-scadenzario.test.js).
//
// PRINCIPI (rito A1/proc-v3):
//  - TESTI VERBATIM dal v1 (admin-module.js, renderScadenzario r.1635-1704 +
//    regoleListHtml r.1605-1634): il contract test pinna OGNI stringa di
//    AS_TEXTS sul sorgente v1 (anche nella forma con apostrofi escapati).
//  - FORMULE del v1 replicate come funzioni pure SOLO dove il v1 le tiene
//    inline (ordine per gruppo col QUIRK gruppo-sconosciuto, conteggio attive,
//    '⚠ da confermare'); il resto DELEGATO alle primitive PURE del v1
//    (regoleFiltrate, ammGruppiCatalogo, descrizioneRegolaData, triggerBadge)
//    — unica fonte di verità, zero drift.
//  - MODALI DELEGATI: editRegola (editor + anteprima obbligatoria),
//    apriModaleRegolaAI (wizard AI), apriCodaProposte (coda proposte).
//    I loro refresh post-save passano da renderScadenzario(mountEl) (r.1989/
//    2033/2127): l'interceptor del motore (install.js, interceptRenderName)
//    li reindirizza su renderPage ⇒ refresh della vista v3, mai HTML v1
//    scritto sopra il root React.
//  - MAI 'nav:badge' o canali nuovi da client/src/amm-v3/** (asserito dai test).

import { apiPathFn } from './api.js';

// ---- metodi di window.AMM che il v3 DELEGA (guardie: senza uno solo di
// questi la vista sarebbe monca ⇒ install inerte, mondo v1 intatto) ----
export const AS_DELEGATED_METHODS = [
  'renderPage',            // il seam stesso (wrap) + refresh post-azione
  'renderScadenzario',     // la vista v1 wrappata + interceptor (drift guard)
  'editRegola',            // editor regola (modale, anteprima obbligatoria) — resta v1
  'apriModaleRegolaAI',    // 'Nuova regola con AI' (wizard modale) — resta v1
  'apriCodaProposte',      // coda 'Aggiornamenti catalogo' (modale) — resta v1
  'ammGruppiCatalogo',     // gruppi del catalogo (pura, unica fonte: v1)
  'regoleFiltrate',        // filtro combinato testo+gruppo+effettive (A5-032, pura v1)
  'descrizioneRegolaData', // colonna ricorrenza (pura v1)
  'triggerBadge',          // badge 'a evento'/'documentale' (HTML v1, iniettato verbatim)
  'toast',                 // conferme visibili (stesso canale del v1)
];

// ---- funzioni di window.api.amm usate dal v3 (stessa API del v1) ----
export const AS_API_PATHS = [
  'regole.list',           // GET /regole — il catalogo
  'proposte.list',         // GET /proposte?stato=proposta — banner coda (best-effort)
  'regole.update',         // toggle attiva {attiva: bool}
  'regole.generaScadenza', // 'Registra evento' → POST /regole/:codice/genera-scadenza
];

// ---- TESTI VERBATIM dal v1 (pinnati dal contract test sul sorgente) ----
export const AS_TEXTS = {
  title: 'Regole degli obblighi',
  titleTooltip: "Tecnicamente 'Catalogo obblighi'",
  subtitle: 'Le regole che generano le scadenze (non le scadenze stesse: quelle sono nel Cruscotto/Calendario) · attive solo quelle pertinenti al profilo',
  attiveSuffix: ' regole attive',
  btnNuovaAi: 'Nuova regola con AI',
  btnNuova: '+ Nuova regola',
  proposteSuffix: ' proposte di aggiornamento in attesa',
  proposteVedi: 'Vedi',            // v1: '<span>Vedi &rarr;</span>' (freccia resa a parte)
  filtroTestoPlaceholder: 'Cerca per titolo, codice o riferimento…',
  filtroTuttiGruppi: 'Tutti i gruppi',
  filtroSoloEffettive: 'Solo effettive',
  footer: 'Le regole grigie sono nel catalogo ma spente perché non applicabili al profilo, o disattivate. Cambia il profilo per accenderle/spegnerle.',
  empty: 'Nessuna regola per il filtro selezionato.',
  nonApplicabile: 'non applicabile',
  daConfermare: '⚠ da confermare',
  registraEvento: 'Registra evento', // v1: 'Registra evento &rarr;' (freccia a parte)
  editTitle: 'Modifica',             // title del pennino ✎ (v1 &#9998;)
  toastRegolaAggiornata: 'Regola aggiornata',
  toastScadenzaCreata: 'Scadenza creata nel mastro',
  errorePrefix: 'Errore: ',
  confermaEventoPre: "Registrare l'adempimento «",
  confermaEventoPost: '» come scadenza da gestire?',
};

// Testi NUOVI del v3, dichiarati: il v1 non ha intestazioni di colonna (righe
// libere raggruppate per gruppo) — il DataTable le richiede; il raggruppamento
// visivo del v1 diventa la colonna 'Gruppo' (deviazione dichiarata D-A2.4,
// stesso precedente di D-A1.4).
export const AS_NEW_TEXTS = {
  colGruppo: 'Gruppo',
  colRegola: 'Regola',
  colPeriodicita: 'Periodicità',
  colRicorrenza: 'Ricorrenza',
  colApplicabilita: 'Applicabilità',
  colAzioni: 'Azioni',
  colAttiva: 'Attiva',
};

// colori VERBATIM v1 (badge attive r.1646, banner proposte r.1651, da confermare r.1623)
export const AS_COLORS = {
  attiveBg: '#ecfeff', attiveFg: '#0e7490',
  proposteBg: '#fef3c7', proposteFg: '#92400e', proposteBorder: '#fde68a',
  daConfermareBg: '#fef3c7', daConfermareFg: '#92400e',
  applicOn: '#475569', applicOff: '#94a3b8',
};

// ---- FORMULE v1 replicate (pure) ----

// regole attive = quelle EFFETTIVE (attiva && applicabile) — r.1640: il badge
// del titolo conta r.effettiva, NON r.attiva, e conta sul catalogo INTERO
// (non sul filtrato).
export function contaAttive(regole) {
  return (regole || []).filter(function (r) { return r.effettiva; }).length;
}

// ordine righe = ordine dei GRUPPI del catalogo, dentro il gruppo l'ordine
// della lista — regoleListHtml r.1609-1612. QUIRK v1 replicato: una regola
// con gruppo NON nel catalogo (chiave sconosciuta) NON compare affatto.
export function regoleOrdinate(regoleFiltrate, gruppiKeys) {
  const out = [];
  for (const g of gruppiKeys || []) {
    for (const r of regoleFiltrate || []) {
      if (r.gruppo === g) out.push(r);
    }
  }
  return out;
}

// badge '⚠ da confermare' — r.1618: descrizione che contiene ⚠
export function isDaConfermare(r) {
  return String((r && r.descrizione) || '').indexOf('⚠') !== -1;
}

// sottoriga della colonna Regola — r.1621: codice (+ ' · ' + riferimento)
export function subRegola(r) {
  return (r.codice || '') + (r.riferimento_normativo ? ' · ' + r.riferimento_normativo : '');
}

// testo conferma 'Registra evento' — r.1683 (VERBATIM, ricomposto)
export function confermaEventoTesto(titolo) {
  return AS_TEXTS.confermaEventoPre + titolo + AS_TEXTS.confermaEventoPost;
}

// ---- LETTURA dati (stessa composizione del v1 r.1637-1639: regole +
// proposte in attesa con catch → [], MAI bloccante) ----
export async function readScadenzario(win) {
  const regole = await apiPathFn(win, 'regole.list').call(null);
  let proposte = [];
  try { proposte = await apiPathFn(win, 'proposte.list').call(null, 'proposta'); } catch (e) { proposte = []; }
  return { regole: regole || [], proposte: proposte || [] };
}

// ---- AZIONI (stessa API del v1) ----
// toggle attiva — r.1670: PATCH /regole/:codice {attiva: !nowOn}
export function toggleRegola(win, codice, attiva) {
  return apiPathFn(win, 'regole.update').call(null, codice, { attiva: attiva });
}
// registra evento — r.1684: POST /regole/:codice/genera-scadenza {}
export function generaScadenzaRegola(win, codice) {
  return apiPathFn(win, 'regole.generaScadenza').call(null, codice, {});
}

// ---- DELEGHE ai modali v1. mountEl = il container REALE (#amm-page): al
// save i modali chiamano renderScadenzario(mountEl), che l'interceptor del
// motore reindirizza su renderPage ⇒ refresh v3 (l'el non viene MAI scritto
// a vista v3 al comando; a registry assente il v1 ridipinge — degrado
// visibile, mai vista bianca). ----
export function apriEditorRegola(win, rec) { win.AMM.editRegola(rec, win.document.getElementById('amm-page')); }
export function apriNuovaRegolaAI(win) { win.AMM.apriModaleRegolaAI(win.document.getElementById('amm-page')); }
export function apriCodaProposteV1(win) { win.AMM.apriCodaProposte(win.document.getElementById('amm-page')); }
// refresh post-azione = STESSA via del v1 (renderPage(currentPage)): passa dal wrap
export function refreshPagina(win) { return win.AMM.renderPage(win.AMM.currentPage); }
